// extracted by mini-css-extract-plugin
module.exports = {"legal":"legal-module--legal--3l8tM","title":"legal-module--title--7XFrq"};